<template>
  <div id="app">
    <dashboard
      v-if="user"
      :user="user"
    ></dashboard>
    <div v-else>In Todos, but user not defined</div>
  </div>
</template>

<script>
import Dashboard from "@/components/Dashboard.vue";

import { Person } from "blockstack";
import { userSession } from "../userSession";

export default {
  name: "Todos",
  components: { Dashboard },
  created() {
    this.userSession = userSession;
  },
  mounted() {
    console.log("Todos mounted");
    if (userSession.isUserSignedIn()) {
      console.log("User is signed in");
      this.userData = userSession.loadUserData();
      this.user = new Person(this.userData.profile);
      this.user.username = this.userData.username;
    } else if (userSession.isSignInPending()) {
      console.log("User sign in pending");
      userSession.handlePendingSignIn().then(userData => {
        console.log("Todos - this should not happen");
        console.log("changing window location origin");
        alert("hello");
        window.location = window.location.origin;
      });
    }
  },
  data() {
    return {
      userSession: null,
      user: null
    };
  }
};
</script>

<style src="@/assets/sass/app.scss" lang="scss"></style>